import { render, staticRenderFns } from "./parkingMana.vue?vue&type=template&id=a2136db0&scoped=true&"
import script from "./parkingMana.vue?vue&type=script&lang=js&"
export * from "./parkingMana.vue?vue&type=script&lang=js&"
import style0 from "./parkingMana.vue?vue&type=style&index=0&id=a2136db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2136db0",
  null
  
)

export default component.exports